import React from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import Modal from 'components/modal';

export default function VoucherCreationSuccess({ deal, onCancel }) {
  return (
    <React.Fragment>
      <Modal.Header closeButton>
        New Voucher
      </Modal.Header>

      <Modal.Body>
        {deal.displayName
          ? <p>A voucher for <strong>{deal.displayName}</strong> was successfully created.</p>
          : <p>A new voucher was successfully created.</p>
        }

        <p>
          Voucher status:
          <label className={`label sm pill-label label-voucher ml-2 ${deal.voucher.statusPillClass}`}>
            {deal.voucher.statusLabel}
          </label>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel label="Close" onClick={onCancel} />
        <Button.Primary href={deal.voucher.path} label="View Voucher" />
      </Modal.Footer>
    </React.Fragment>
  );
}

VoucherCreationSuccess.propTypes = {
  deal: PropTypes.shape({
    displayName: PropTypes.string,
    voucher: PropTypes.shape({
      path: PropTypes.string.isRequired,
      statusPillClass: PropTypes.string,
      statusLabel: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
};
